// @flow

import type { ExtractReturn } from '@ta/common.types';
import type { Action as AllActions } from './state';

const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const changeLocale = (
  locale: string,
  isRtl: boolean,
  ietfLocale: string,
  distanceUnit: string,
  firstDayOfWeek: number,
) => ({
  type: CHANGE_LOCALE,
  locale,
  isRtl,
  ietfLocale,
  distanceUnit,
  firstDayOfWeek,
});

export type Action = ExtractReturn<typeof changeLocale>;

const emptyState = () => ({
  locale: 'en_US',
  ietfLocale: 'en-US',
  isRtl: false,
  currencyCode: 'USD',
  distanceUnit: 'MILES',
  firstDayOfWeek: 0, // 0 is Sunday, 1 is Monday, etc
});

export type State = ExtractReturn<typeof emptyState>;

export default (state: State = emptyState(), action: AllActions): State => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return {
        ...state,
        locale: action.locale,
        ietfLocale: action.ietfLocale,
        isRtl: action.isRtl,
        distanceUnit: action.distanceUnit,
        firstDayOfWeek: action.firstDayOfWeek,
      };
    default:
      return state;
  }
};
